import { ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { BaseListComponent } from '../../../../../../components/base-list.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import { AdminUserService } from '../../../../../../common/services/admins/user.service';
import { AgentConst } from '../../expert/agent/agent.const';
import { Observable } from 'rxjs';
import { UtilityService } from '../../../../../../common/services/Utility.service';
import { FormFieldType, ModalType } from '../../../../../../components/modals/modal-form-template/modal-form.const';
import { TableAction } from '../../../../../../components/table-component/table.const';
import { isEmail } from '../../../../../../common/utils/validate';
import * as _ from 'lodash';
import { SocketListener } from '../../../../../../layout/header/socket.listener';

@Component({
  selector: 'setting-account-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css'],
})
export class TenantUserComponent extends BaseListComponent {
  @ViewChild('templateUser') templateUser: ElementRef;
  @Input() tenantId: string = null;
  @Input() tenant: any = null;

  public allGroups: any[] = [];
  public allRole: any = [{ id: '', text: 'Vai trò' }, ...AgentConst.userRoleArray()];
  public targetUser: any = {};
  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private userService: AdminUserService,
    private socketListener: SocketListener
  ) {
    super(changeDetector, toastr, modalService);
    this.displayColumns = AgentConst.displayColumns();
  }

  async ngOnInit() {
    Observable.forkJoin([this.userService.group(this.tenantId, { target: 'user' })]).subscribe(data => {
      this.loadGroup(data[0]);
      this.loadData();
    });
  }
  async loadData(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.userService.list(this.tenantId, payload).subscribe(res => {
      if (res.status == 200 && res.error == false) {
        this.data = res.data.list;
        this.data.map(r => {
          r.display_role = AgentConst.displayRoleColumns(r, this.user._id);
          r.display_active = AgentConst.displayActiveColumns(r);
          r.status = r.active;
          return r;
        });
        this.initPage(res.data.total);
      }
    });
  }
  loadGroup(res) {
    if (res.status == 200 && !res.error) {
      let group = [{ id: '', text: 'Bộ phận' }];
      res.data.list.forEach((c: any) => {
        group.push({
          text: c.name,
          id: c.id,
        });
      });
      this.allGroups = group;
    }
  }

  async search() {
    this.currentPage = 1;
    const filters = [];
    if (this.modelFilter.keyword && this.modelFilter.keyword.trim() != '') {
      const isnum = UtilityService.isValidPhoneNumber(this.modelFilter.keyword.trim());
      if (!isnum) {
        this.modelFilter.keyword
          .replace(/\s+/g, ' ')
          .trim()
          .split(' ')
          .forEach(element => {
            filters.push({
              key: 'name',
              condition: 'like',
              value: element.toLowerCase(),
            });
          });

        await this.loadData({ filters: JSON.stringify(filters) });
      } else {
        filters.push({
          key: 'phone',
          condition: '=',
          value: this.modelFilter.keyword.trim(),
        });
        await this.loadData({ filters: JSON.stringify(filters) });
      }
    } else {
      await this.loadData();
    }
  }
  async addUser() {
    const payload = {
      name: this.model.name,
      email: this.model.email,
      role: this.model.role,
      group_id: this.model.group_id,
    };
    this.userService.create(this.tenantId, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Thêm mới thành công!');
          this.closeModal();
          setTimeout(() => {
            this.loadData();
          }, 1000);
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async resetPassword() {
    const payload = {
      password: this.model.password,
    };
    this.userService.resetPassword(this.tenantId, this.targetUser._id, payload).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.throwSuccess('Đổi mật khẩu thành công!');
          this.closeModal();
          setTimeout(() => {
            this.loadData();
          }, 1000);
        } else {
          this.message = {
            class: 'alert dark alert-danger',
            content: res.message,
          };
        }
      },
      error => {
        this.message = {
          class: 'alert dark alert-danger',
          content: error.message,
        };
      }
    );
  }

  async active(id, status) {
    if (status === undefined || status === null) {
      status = true;
    }
    this.userService.active(this.tenantId, id, { active: status }).subscribe(
      res => {
        if (res.status == 200 && !res.error) {
          this.is_loading = true;
          setTimeout(() => {
            this.data.map(r => {
              if (r._id === id) {
                r.status = status;
              }
              return r;
            });
            this.throwSuccess(status ? 'Kích hoạt thành công!' : 'Dừng hoạt động thành công!');
            this.is_loading = false;
          }, 1000);
        } else {
          this.throwError(res.message);
        }
      },
      error => {
        this.throwError(error.message);
      }
    );
  }

  async setUpModel() {
    switch (this.typeModal) {
      case 'add':
        this.modelContent = {
          type: ModalType.Primary,
          title: 'Tạo mới chuyên viên',
          submit_title: 'Thêm mới',
        };
        this.modelDisplay = [
          {
            key: 'name',
            label: 'Tên chuyên viên',
            type: FormFieldType.Text,
            value: this.model.name,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
          },
          {
            key: 'email',
            label: 'Email chuyên viên',
            type: FormFieldType.Text,
            value: this.model.email,
            required: true,
            disabled: false,
            width: 'full',
            order: 1,
          },
          {
            key: 'role',
            label: 'Vai trò',
            type: FormFieldType.Select2,
            value: this.model.role,
            required: true,
            disabled: false,
            width: 'full',
            order: 2,
            options: {
              data: this.allRole,
              select2Options: {
                placeholder: { id: '', text: 'Vai trò' },
              },
            },
          },
          {
            key: 'group_id',
            label: 'Bộ phận',
            type: FormFieldType.Select2,
            value: this.model.group_id,
            required: true,
            disabled: false,
            width: 'full',
            order: 4,
            options: {
              data: this.allGroups,
              select2Options: {
                placeholder: { id: '', text: 'Bộ phận' },
              },
            },
          },
        ];
        break;
      case 'resetPassword':
        this.modelContent = {
          type: ModalType.Primary,
          title: 'Đổi mật khẩu',
          submit_title: 'Thực hiện',
        };
        this.modelDisplay = [
          {
            key: 'password',
            label: 'Mật khẩu',
            type: FormFieldType.Hidden,
            value: this.model.password,
            required: true,
            disabled: false,
            width: 'full',
            order: 0,
          },
          {
            key: 're_password',
            label: 'Xác nhận mật khẩu',
            type: FormFieldType.Hidden,
            value: this.model.re_password,
            required: true,
            disabled: false,
            width: 'full',
            order: 1,
          },
        ];
        break;
    }
  }

  async handleAction(type: any, item?: any) {
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
      class: 'modal-md',
    };
    switch (type) {
      case TableAction.add:
        this.typeModal = 'add';
        this.model = {};
        await this.setUpModel();
        this.openModal(this.templateUser, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.lock:
        this.targetUser = item;
        this.typeModal = 'resetPassword';
        this.model = {};
        await this.setUpModel();
        this.openModal(this.templateUser, config, this.model, {
          modelContent: this.modelContent,
          modelDisplay: this.modelDisplay,
        });
        break;
      case TableAction.signIn:
        await this.signInAgent(item);
        break;
      case TableAction.active:
        await this.active(item._id, item.status);
        break;
    }
  }

  async handleSubmit(item?: any) {
    this.model = _.merge({}, this.model, item);
    switch (this.typeModal) {
      case 'add':
        await this.addUser();
        break;
      case 'resetPassword':
        if (this.model.password.length < 6) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Mật khẩu ít nhất phải có 6 ký tự!',
          };
          break;
        }
        if (this.model.re_password && this.model.password && this.model.password !== this.model.re_password) {
          this.message = {
            class: 'alert dark alert-danger',
            content: 'Mật khẩu nhập lại không đúng!',
          };
          break;
        }
        await this.resetPassword();
        break;
    }
  }

  async onChangeValueModel(key, item?: any) {
    this.model = _.merge({}, this.model, item);
    this.message = null;
    switch (this.typeModal) {
      case 'add':
        switch (key) {
          case 'email':
            if (!isEmail(this.model[key]) && item[key]) {
              this.message = {
                class: 'alert dark alert-danger',
                content: 'Email không đúng định dạng!',
              };
            }
            break;
        }
        break;
      case 'resetPassword':
        break;
    }
    await this.setUpModel();
  }

  async signInAgent(user) {
    const conf = confirm('Bạn có chắc chắn muốn đăng nhập vào tài khoản này!');
    if (conf) {
      const payload = {
        tenant: this.tenant,
        email: user.email,
      };
      this.userService.signIn(this.tenantId, payload).subscribe(
        res => {
          if (res.status == 200 && !res.error) {
            this.socketListener.onReLogin.emit(res.data);
          } else {
            this.throwError(res.message);
          }
        },
        error => {
          this.throwError(error.message);
        }
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/account/user/user.component.ts